import { getUrl, Request } from "../../request";

export const getProductSliders = (city_id, category_id, home_page = false) => {
  const query = {
    city_id,
    category_id,
  };
  if (home_page) {
    query["home_page"] = 1;
  }
  return Request.get(getUrl("/api/v1/sellers/product-sliders/"), query);
};

export const getSellerProducts = (city_id, category_id, filter_query) => {
  return Request.get(getUrl("/api/v1/sellers/products/"), {
    ...filter_query,
    city_id,
    category_id,
  });
};

export const getProductsSearch = (city_id, search) => {
  return Request.get(getUrl("/api/v1/sellers/products-search/"), {
    city_id,
    search,
  });
};

export const postCard = (seller_product_id, city_id, quantity, cart_items) => {
  return Request.post(getUrl("/api/v1/sellers/card/"), {
    seller_product_id,
    city_id,
    quantity,
    cart_items,
  });
};

export const getProductsFilters = (category_id, city_id) => {
  return Request.get(getUrl("/api/v1/sellers/products-filters/"), {
    category_id,
    city_id,
  });
};

export const getProductDelivery = (seller_product_id, city_id, type) => {
  return Request.get(getUrl("/api/v1/sellers/product-delivery/"), {
    seller_product_id,
    city_id,
    type,
  });
};
